<template lang="baseLang">
<div>
    <div class="Vlt-native-dropdown Vlt-native-dropdown--app" align="left">
        <select v-model="skin">
            <option v-for="(skin,index) in skins" v-bind:key="index" :value="skin">{{ skin.name }}</option>
        </select>
    </div>
    <div v-if="skin.fields">
        <div v-for="product in skin.fields.products" v-bind:key="product.id" class="Vlt-col">
            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-1of4">
                    <div class="Vlt-card">
                        <h4>{{ t(product.name) }} {{skin.fields.role1}}</h4>
                        <vlt-button style="justify-content: center" app quaternary :label="t('Open in New Tab')" @click="openWindow('finder')" /><br>
                        <qrcode :value="
              'https://vids.vonage.com/tile/#/finder?uid=' +
              nexmo.userid +
              '&product=' +
              product.id +
              '&language=' +
              lang.thisCode +
              '&location=' +
              0 +
              '&flavor='+skin.name
            " :options="{ width: 150 }"></qrcode>
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-1of4">

                    <div class="Vlt-card">
                        <h4>{{ t(product.name) }} {{skin.fields.role2}}</h4>
                        <vlt-button style="justify-content: center" app quaternary :label="t('Open in New Tab')" @click="openWindow('owner')" /><br>
                        <qrcode :value="
              'https://vids.vonage.com/tile/#/owner?uid=' +
              nexmo.userid +
              '&product=' +
              product.id +
              '&language=' +
              lang.thisCode +
              '&location=' +
              0+
              '&flavor='+skin.name

            " :options="{ width: 150 }"></qrcode>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br /><br />
    <div class="Vlt-grid">
        <div class="Vlt-col Vlt-col--A-1of4">
            <vlt-button style="justify-content: center" app quaternary :label="t('Clear Demo')" @click="clear" />
        </div>
        <div v-if="skin.fields && skin.fields.CC" class="Vlt-col Vlt-col--A-1of4">
            <vlt-button :label="t('Open Contact Center')" quaternary app @click="purecloud" />
        </div>
        <div v-if="false" class="Vlt-col Vlt-col--A-2of4">
            <h4 style="display: inline-block;margin-right:5px">Customer's Language: </h4>
            <div v-if="languages" class="Vlt-native-dropdown">
                <select v-model="langSel" @change="languageChange">
                    <option v-for="(lang,index) in languages" v-bind:key="index" :value="lang.language">{{ lang.name }}</option>
                </select>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { $HTTP } from "@/services/nidsInternal.js";
import {
  VltIcon,
  VltButton,
  VltCard,
  VltTab,
  VltGrid,
  VltCol,
  VltField,
} from "@vonagevolta/vue";
import { $BASE, $NODEBASE } from "@/base";
import axios from "axios";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import localization from "@/components/localization";

export default {
  name: "qrcodes",
  components: {
    "vlt-icon": VltIcon,
    "vlt-button": VltButton,
    qrcode: VueQrcode,
    localization,
  },
  props: {
    nexmo: {
      type: Object,
      required: false,
    },
    demoItem: {
      type: Object,
      required: false,
    },
    baseLang: {
      type: Object,
      required: false,
    },
    lang: {
      type: Object,
      required: false,
      default: {
        thisCode: "en-US",
      },
    },
  },
  data() {
    return {
      NODEDEMO: {},
      products: [],
      flavor: "tile",
      demo: "retail",
      languages: null,
      langSel: "en-US",
      skins: [
        {
          name: "tile",
          product: "Tile",
          role1: "Finder",
          role2: "Owner",
          products: [
            {
              id: "9aab9736-0b74-44e0-8f1e-45f9033343a5",
              name: "Tile Pro",
              line1: "",
              line2: "",
            },
          ],
          logo: "https://vids.vonage.com/tile/tile2.png",
          productText: "This item is lost:",
          productImage: "https://vids.vonage.com/tile/circletile.png",
          useVerify: true,
          useCall: true,
          useText: true,
          useSMS: true,
          useWA: true,
          useNotes: true,
          useImages: true,
          useVideo: true,
        },
      ],
      skin: null,
    };
  },
  created() {
    if (!this.lang) {
      this.lang = {
        thisCode: "en-US",
      };
    }
    this.skin = this.skins[0];
    var postscript = "/" + this.demo;
    if ($NODEBASE.indexOf("ngrok") > 0) {
      postscript = "";
    }
    let nodeurl = $NODEBASE + postscript;
    this.NODEDEMO = axios.create({
      baseURL: nodeurl,
      headers: {
        "Content-Type": "application/json",
      },
    });
    /*
        this.NODEDEMO.post("/products", {
          type: this.flavor,
        }).then(async (result) => {
          console.log("Registration returned: ", result.data);
          this.products = result.data.products;
        });
        */
    $HTTP
      .post("localization", {
        demoId: 117,
        type: 1,
      })
      .then((result) => {
        //console.log("Demo languages= ", result.data + "with gather = "+ globalStore.$gather);
        if (result.data.length > 1) {
          console.log("Skins result: ", result.data);
          this.skins = result.data;
          this.skins.forEach((skin) => {
            skin.fields = JSON.parse(skin.json_data).fields;
          });
          this.skin = this.skins[0];
          console.log("New skin: ", this.skin);
        }
      });
  },
  watch: {
    lang: function (newVal) {
      console.log("New Lang: ", this.lang);
      //      this.NODEDEMO.post("/update", {
      //        language: this.lang.thisCode,
      //      });
      // Any strings that need to be dynamically changed on Language Change go here...
      //this.message = this.t(this.message);
    },
  },
  beforeDestroy() {},
  computed: {},
  methods: {
    baseLang1(base) {
      console.log("Setting baselang: ", base);
      this.baseLang = base;
    },
    languageChange() {
      console.log(
        "Language changed for " + this.nexmo.userid + "...",
        this.langSel
      );
      this.NODEDEMO.post("/language", {
        id: this.nexmo.userid,
        userType: "agent",
        lang: this.langSel,
      });
    },
    clear() {
      console.log("In clear");
      this.NODEDEMO.post("/clear", {
        id: this.nexmo.userid,
      });
    },
    openWindow(which) {
      let url =
        "https://vids.vonage.com/tile/#/" +
        which +
        "?uid=" +
        this.nexmo.userid +
        "&product=" +
        this.skin.fields.products[0].id +
        "&language=" +
        this.lang.thisCode +
        "&location=" +
        0 +
        "&flavor=" +
        this.skin.name;
      window.open(url, "_blank");
    },
    purecloud() {
      window.open(this.skin.fields.CC, "_blank");
      //"https://apps.usw2.pure.cloud/directory/", "_blank");
    },
    t(key) {
      // T for Translate...
      return this.$tr(key, this.lang, this.baseLang);
    },
  },
};
</script>

<style scoped>
.Vlt-card {
  height: 100%;
  border-bottom-right-radius: 18px;
}

.Vlt-gradient--pink-to-peach {
  border-radius: 18px;
  height: calc(100% - 24px);
  padding-right: 6px;
  padding-bottom: 6px;
}

.odd {
  background: #eee;
}

.clickable {
  cursor: pointer;
}
</style>
